<template>
  <div v-loading="loading" class="ht-ducument-list">
    <template v-if="filteredData.length > 0">
      <div class="ht-ducument-body">
        <document-card
          v-for="(ducument, index) in paginatedData"
          :key="ducument.id"
          :ducument="{ ...ducument, index }"
        />
      </div>
      <div class="ht-ducument-footer">
        <el-pagination
          v-if="total > 0"
          background
          layout="total, sizes,prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :current-page="currentPage"
          style="margin-top: 20px; text-align: right"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handlePageSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </template>

    <el-empty v-else />
  </div>
</template>

<script>
  import DocumentCard from './component/DocumentCard.vue'
  import debounce from 'lodash/debounce'
  import { queryDocList } from '@/api/flow'
  import { addEventLog } from '@/api/base'
  import moment_tz from 'moment-timezone'
  export default {
    name: 'HtDocumentList',

    components: { DocumentCard },

    props: {
      pattern: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        loading: false,
        allData: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        debouncedHandleSearch: debounce(this.handleSearch, 250),
      }
    },

    computed: {
      filteredData() {
        return this.allData
      },
      paginatedData() {
        return this.allData
      },
    },

    watch: {
      pattern: {
        immediate: true,
        handler() {
          this.currentPage = 1
          this.debouncedHandleSearch()
        },
      },
    },

    methods: {
      async handleSearch() {
        this.loading = true

        try {
          // 构建请求参数
          const requestParams = {
            pageBean: {
              page: this.currentPage,
              pageSize: this.pageSize,
              total: 0,
            },
            sorters: [
              //排序信息
              {
                property: 'doc.effective_time', //生效时间
                direction: 'DESC',
              },
            ],
            querys: [
              //查询条件  -默认会加上只查询已发布的文档
              {
                property: 'doc.title', //文档标题
                value: this.pattern,
                group: 'quick',
                relation: 'AND',
                operation: 'LIKE',
              },
            ],
          }

          const response = await queryDocList(requestParams)

          this.allData = response.rows.map((item) => ({
            // 文档标题
            title: item.title,
            //文档目录
            category: item.docCatalogueLabel,
            //文档版本
            version: 'v' + item.docVersion,
            //文档状态
            status: item.docStatusLabel,
            //文档编码
            ducumentCode: item.docCode,
            //文档创建时间
            startTime: moment_tz
              .utc(item.createdTime)
              .tz(moment_tz.tz.guess())
              .format('YYYY-MM-DD'),
            //文档所属人
            initiator: item.docOwnerName,
            //文档AI概要结果，预留
            // aiSummary: item.aiSummaryResult,
            instanceId: item.id,
            //文档链接
            dmsUrl: item.dmsUrl,
          }))
          this.total = response.total || 0
        } catch (e) {
          console.error('搜索文档失败:', e)
          this.allData = []
          this.total = 0
        } finally {
          this.loading = false
          await addEventLog({
            type: '文档',
            content: this.pattern,
          })
        }
      },

      handlePageChange(page) {
        this.currentPage = page
        this.handleSearch()
        // ht-ducument-body滚动条滚动到顶部
        const bodyElement = this.$el.querySelector('.ht-ducument-body')
        if (bodyElement) {
          bodyElement.scrollTop = 0
        }
      },
      handlePageSizeChange(size) {
        this.pageSize = size
        this.currentPage = 1
        this.handleSearch()
        const bodyElement = this.$el.querySelector('.ht-ducument-body')
        if (bodyElement) {
          bodyElement.scrollTop = 0
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ht-ducument-list {
    display: flex;
    flex-direction: column;
    height: 98%;
    padding: 0 12px 12px;
    overflow: hidden;
  }

  .ht-ducument-body {
    flex: 1;
    margin-bottom: 12px;
    overflow-y: auto;
  }

  .ht-ducument-footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 40px;
  }
</style>
